module.exports = __webpack_public_path__ + "sr.svg?ceae0ffa4c003d02ae6151089d91a88d";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/sr.svg
// module id = 1623
// module chunks = 0